import { z } from 'zod';

export const hostTargetSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('local') }).strict(),
  z.object({ kind: z.literal('remote'), machineId: z.string().min(1).max(128) }).strict(),
]);

export const remoteHostOptionSchema = z.object({
  machineId: z.string().min(1).max(128),
  label: z.string().min(1).max(256),
  associatedCampaignId: z.string().min(1).max(128),
  associatedCampaignName: z.string().min(1).max(256),
  online: z.boolean(),
}).strict();

export const localHostDescriptorSchema = z.object({
  machineId: z.string().min(1).max(128),
  label: z.string().min(1).max(256),
  branch: z.string().min(1).max(128),
  hostVersion: z.string().min(1).max(128),
  protocolVersion: z.literal(1),
  playjectorConnected: z.boolean(),
  realtimeConnected: z.boolean(),
  videoReconnectSupported: z.boolean().optional(),
}).strict();

export const connectedHostSchema = z.object({
  kind: z.enum(['local', 'remote']),
  machineId: z.string().min(1).max(128),
  sessionId: z.string().uuid(),
}).strict();

export type HostTarget = z.infer<typeof hostTargetSchema>;
export type RemoteHostOption = z.infer<typeof remoteHostOptionSchema>;
export type LocalHostDescriptor = z.infer<typeof localHostDescriptorSchema>;
export type ConnectedHost = z.infer<typeof connectedHostSchema>;
